<template>
  <div>
    <v-card color="grey lighten-5 ma-0 pa-0" :loading="loading">
      <document-action-header :title="$t('History')" @on-close-click="onCloseClick" />
      <v-card-text class="overflow-y-auto" style="max-height: 250px;">
        <div v-for="history in historyList" v-bind:key="history.date">
          <v-chip class="ml-2">
            <span class="font-weight-bold">{{history.date}}</span>
          </v-chip>
          <v-timeline v-bind:key="history.date" align-top dense>
            <history-item :historyItems="history.items" />
          </v-timeline>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DocumentActionHeader from "@/components/search/results/list/item/actions/DocumentActionHeader";
import HistoryItem from "@/components/search/results/list/item/actions/history/HistoryItem";
import DocumentService from "@/services/DocumentService";
import History from "@/ecm/models/search/results/list/History";

export default {
  name: "HistoryList",
  components: {
    DocumentActionHeader,
    HistoryItem
  },
  props: {
    documentId: {
      type: Number,
      required: true
    }
  },
  created() {
    this.loadData();
  },
  data() {
    return {
      historyList: [],
      loading: false
    };
  },
  methods: {
    onCloseClick() {
      this.$emit("on-close-click");
    },
    loadData() {
      this.loading = true;
      DocumentService.getHistoryList(this.documentId).then(data => {
        this.historyList = data.map(function(dto) {
          return new History(dto);
        });
        this.loading = false;
      });
    }
  }
};
</script>